export enum EEmployeeContract {
  PERMANENT = 'permanent',
  FIXED_TERM = 'fixed_term',
}
